import propTypes from 'prop-types';

import { PesIcon } from '@pes-ui/components-react';
import { pesIconSizes } from '@pes-ui/components/dist/collection/components/UI/pes-icon/constants';

const DeleteIcon = ({ onClickHandler, label }) => (
  <button type="button" className="button-less delete-block" onClick={onClickHandler}>
    <PesIcon class="delete-block__icon" size={pesIconSizes.SMALL}>
      action_delete
    </PesIcon>
    {label && <span className="delete-block__label actions-block__cta pes-link">{label}</span>}
  </button>
);

DeleteIcon.propTypes = {
  onClickHandler: propTypes.func.isRequired,
  label: propTypes.string
};

DeleteIcon.defaultProps = {
  label: undefined
};

export { DeleteIcon };
